import { type SmartMentionConfig, SmartMentionResource } from '@atlassian/smart-mention-resource';

const BaseSmartMentionConfigOptions: Omit<SmartMentionConfig, 'siteId' | 'principalId'> = {
	env: 'prod',
	productKey: 'jira',
	includeTeams: true,
	includeUsers: false,
};

export class TeamMentionProvider extends SmartMentionResource {
	constructor({
		cloudId,
		orgId,
		userId,
	}: {
		cloudId: string;
		userId: string | null;
		orgId?: string;
	}) {
		super({
			...BaseSmartMentionConfigOptions,
			siteId: cloudId,
			orgId,
			principalId: userId ?? undefined,
		});
	}
}
